import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen px-3 py-16 text-slate-950 sm:px-4 md:px-10 md:py-[5rem]" }
const _hoisted_2 = { class: "mx-auto grid max-w-6xl grid-cols-1 gap-5 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:gap-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-6 text-2xl font-bold" }, "Carrinho", -1)
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "space-y-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Resumo do pedido", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-700" }, " A opção \"Retire na loja\" é apenas para retirada na matriz da enerzee: Av. Miguel Sutil, 690 - Edifício Verona Tower, 5° andar, Jardim Paulista, Cuiabá - MT. ", -1)
const _hoisted_8 = {
  key: 0,
  class: "rounded-xl bg-red-50 p-3 text-sm text-red-700"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "text-center text-xs text-slate-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPayments = _resolveComponent("ModalPayments")!
  const _component_CheckoutCartItem = _resolveComponent("CheckoutCartItem")!
  const _component_CheckoutAddressCard = _resolveComponent("CheckoutAddressCard")!
  const _component_CheckoutFreightOptions = _resolveComponent("CheckoutFreightOptions")!
  const _component_CheckoutValuesCard = _resolveComponent("CheckoutValuesCard")!
  const _component_CheckoutPaymentCard = _resolveComponent("CheckoutPaymentCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalPayments, {
      show: _ctx.showPaymentResult,
      onClose: _ctx.closePixPayment,
      loading: _ctx.loadingPayment,
      regenerate: _ctx.finishPayment,
      restartingQR: _ctx.restartingQR,
      errorMessage: _ctx.errorMessage
    }, null, 8, ["show", "onClose", "loading", "regenerate", "restartingQR", "errorMessage"]),
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", null, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems.slice(1), (cartItem) => {
              return (_openBlock(), _createBlock(_component_CheckoutCartItem, {
                key: `${cartItem.product_id}-${cartItem.color}-${cartItem.size}`,
                "cart-item": cartItem,
                onQuantity: _ctx.changeCartQuantity,
                onRemove: _ctx.removeCartItem
              }, null, 8, ["cart-item", "onQuantity", "onRemove"]))
            }), 128))
          ])
        ]),
        _createElementVNode("aside", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_CheckoutAddressCard, {
            "user-addresses": _ctx.checkoutUserAddresses,
            "selected-address": _ctx.selectedAddress,
            address: _ctx.address,
            cep: _ctx.newAddressCep,
            number: _ctx.newAddressNumber,
            complement: _ctx.newAddressComplement,
            "show-new-address-form": _ctx.showNewAddressForm,
            "saving-address": _ctx.savingAddress,
            "deleting-address-id": _ctx.deletingAddressId,
            "onUpdate:cep": _cache[0] || (_cache[0] = ($event: any) => (_ctx.newAddressCep = $event)),
            "onUpdate:number": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newAddressNumber = $event)),
            "onUpdate:complement": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newAddressComplement = $event)),
            onSelectAddress: _ctx.selectCheckoutAddress,
            onSearchCep: _ctx.searchTypedAddress,
            onUseNewAddress: _ctx.useTypedAddress,
            onDeleteAddress: _ctx.deleteAddress
          }, null, 8, ["user-addresses", "selected-address", "address", "cep", "number", "complement", "show-new-address-form", "saving-address", "deleting-address-id", "onSelectAddress", "onSearchCep", "onUseNewAddress", "onDeleteAddress"]),
          _hoisted_7,
          _createVNode(_component_CheckoutFreightOptions, {
            options: _ctx.freightOptions,
            "selected-freight": _ctx.selectedFreight,
            loading: _ctx.loading,
            onSelect: _ctx.selectFreightOption
          }, null, 8, ["options", "selected-freight", "loading", "onSelect"]),
          _createVNode(_component_CheckoutValuesCard, {
            destination: _ctx.addressDestination,
            prompt: _ctx.prompt,
            "products-value": _ctx.finalProductPrice,
            "freight-value": _ctx.fretePrice,
            "total-value": _ctx.totalPrice
          }, null, 8, ["destination", "prompt", "products-value", "freight-value", "total-value"]),
          _createVNode(_component_CheckoutPaymentCard, {
            options: _ctx.paymentOptions,
            "data-ecash": _ctx.dataEcash,
            "data-pix": _ctx.dataPix,
            "data-credit-card": _ctx.dataCreditCard,
            "total-price": _ctx.totalPrice,
            "e-cash-balance": _ctx.eCashValue + _ctx.userSaldo,
            "card-info": _ctx.cardInfo,
            "personal-info": _ctx.personalInfo,
            form: _ctx.form,
            errors: _ctx.errors,
            months: _ctx.months,
            years: _ctx.getYears(),
            states: _ctx.states,
            onToggle: _ctx.togglePayment,
            "onUpdate:dataEcash": _cache[3] || (_cache[3] = ($event: any) => {_ctx.dataEcash = $event; _ctx.eCashMask()}),
            "onUpdate:dataPix": _cache[4] || (_cache[4] = ($event: any) => {_ctx.dataPix = $event; _ctx.pixMask()}),
            "onUpdate:dataCreditCard": _cache[5] || (_cache[5] = ($event: any) => {_ctx.dataCreditCard = $event; _ctx.creditCardMask()}),
            onUpdateForm: _ctx.updatePaymentForm
          }, null, 8, ["options", "data-ecash", "data-pix", "data-credit-card", "total-price", "e-cash-balance", "card-info", "personal-info", "form", "errors", "months", "years", "states", "onToggle", "onUpdateForm"]),
          (_ctx.messageFailPayment != '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.messageFailPayment), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["h-14 w-full rounded-2xl text-sm font-bold text-white transition", _ctx.selectedFreight == '' || (!_ctx.pixChoice && !_ctx.eCashChoice && !_ctx.creditCardChoice) ? 'bg-slate-400' : 'bg-slate-950 hover:bg-slate-800']),
            disabled: _ctx.selectedFreight == '' || (!_ctx.pixChoice && !_ctx.eCashChoice && !_ctx.creditCardChoice),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.finishPayment()))
          }, " Finalizar pagamento ", 10, _hoisted_9),
          (!_ctx.pixChoice && !_ctx.eCashChoice && !_ctx.creditCardChoice)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Selecione ao menos uma forma de pagamento"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}